export default {
    url: '/employee',
    template: `
        <courses-courses-edit-occurrence-add-employee
            occurrence="vm.occurrence"
            can-manage-occurrences="vm.$scope.$parent.vm.canManageOccurrences"
            course="vm.course"
        />
    `,
    resolve: {
        occurrence (OccurrenceResource, $stateParams) {
            return OccurrenceResource.get({ id: $stateParams.occurrenceId, expand: 'sites,courseOccurrenceLanguages' }).$promise;
        }
    },
    controller ($scope, occurrence, course, OccurrenceService) {
        this.$scope = $scope;
        $scope.$parent.vm.step = 2;
        $scope.$parent.vm.occurrence = occurrence;
        $scope.$parent.vm.canManageOccurrences = !OccurrenceService.isReadonlyOccurrence(occurrence);
        this.occurrence = occurrence;
        this.course = course;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/occurrence/add/employee/index.js